import { useLocation } from "react-router-dom";
import CAR from "../../../Images/customer/policy-car.svg";
import TWO from "../../../Images/customer/policy-bike.svg";
import HLT from "../../../Images/customer/policy-health.svg";
import { useEffect, useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import axios from "axios";

const EndorseForm = () => {
    const location = useLocation();
    const { PolicyEndorse } = location.state;
    const [IsOTP, setIsOTP] = useState(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [formData, setFormData] = useState({
        PolicyNo: PolicyEndorse.PolicyNo,
        PolicyType: PolicyEndorse.PolicyType,
        otp: "",
        ChangeVehicleNo: false,
        ChangeEngineNumber: false,
        ChangeChassisNo: false,
        ChangeMakeModelVariant: false,
        ChangeFuelType: false,
        ChangeName: false,
        ChangeAddress: false,
        ChangeEmailId: false,
        ChangeMobileNo: false,
        ChangeDeductible: false,
        ChangePremiumMismatch: false,
        RequestLetterBase64: "",
        RCCopyBas64: "",
        EmailId: "",
        MobileNo: "",
        Premium: 0,
        Deductible: 0,
    });
    console.log(formData, "Data")

    const validateForm = () => {
        // Required fields for validation
        const requiredFields = ["EmailId", "MobileNo", "Premium", "Deductible"];

        // Check if any of the checkboxes are checked
        const isAnyChangeSelected = Object.keys(formData).some(
            (key) => key.startsWith("Change") && formData[key] === true
        );

        // Check if required fields are filled when corresponding checkboxes are checked
        const areRequiredFieldsFilled = requiredFields.every((field) => {
            if (!formData[`Change${field}`]) return true; // If the related checkbox isn't checked, ignore it

            const value = formData[field];
            return value !== null && value !== undefined && String(value).trim() !== "";
        });

        // Check if file uploads are required and provided
        const areFilesUploaded =
            (!formData.ChangeVehicleNo &&
                !formData.ChangeEngineNumber &&
                !formData.ChangeChassisNo &&
                !formData.ChangeMakeModelVariant &&
                !formData.ChangeFuelType &&
                !formData.ChangeName &&
                !formData.ChangeAddress) ||
            (formData.RequestLetterBase64 && formData.RCCopyBas64);

        // Final validation
        setIsSubmitDisabled(!isAnyChangeSelected || !areRequiredFieldsFilled || !areFilesUploaded);
    };


    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: reader.result,
                }));
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const token = localStorage.getItem("smc-csp-token");

    const GetEndorsement = async () => {
        try {
            const otp = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Policies/sendEndorsementOtp",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (otp.data.StatusCode === 200 && otp.data.StatusMessage === "SUCCESS") {
                setIsOTP(true);
            }
            console.log({ otp });
            alert("OTP sent successfully!");
        } catch (error) {
            console.error("Error sending endorsement request or OTP:", error);
            alert("Failed to send OTP. Please try again.");
        }
    };

    const SubmitOTP = async () => {
        try {
            const response = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Policies/EndorsementRequest",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log({ response });
            setIsOTP(false);
        } catch (error) {
            console.error("Error submitting OTP:", error);
            alert("Failed to submit OTP. Please try again.");
        }
    };

    useEffect(() => {
        validateForm();
    }, [formData]);
    //console.log(PolicyEndorse, "PD");
    return (
        <>
            {!IsOTP ? (
                <>
                    <h4>Policy endorsement</h4>
                    <div className="Renew-Card EndorseForm">
                        <div className="Renew-Card-Icon">
                            {PolicyEndorse.PolicyType === "CAR" && <img alt="" src={CAR} />}
                            {PolicyEndorse.PolicyType === "TWO" && <img alt="" src={TWO} />}
                            {PolicyEndorse.PolicyType === "HLT" && <img alt="" src={HLT} />}
                        </div>
                        <div className="Renew-Card-CNT">
                            <b>
                                {PolicyEndorse.VehicleNo}
                                <br />
                            </b>
                            Policy No: {PolicyEndorse.PolicyNo}
                        </div>
                    </div>

                    <div className="Endorsement box-1">
                        <h5>Select type of endorsement</h5>
                        <ul>
                            <li>
                                <p>Engine Number:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="engineNumberCheckbox"
                                        className="checkbox-input"
                                        name="ChangeEngineNumber"
                                        checked={formData.ChangeEngineNumber}
                                        onChange={handleChange}
                                    />
                                    <label
                                        for="engineNumberCheckbox"
                                        className="checkbox-label"
                                    ></label>
                                </div>
                            </li>
                            <li>
                                <p>Chassis Number:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="chassisNumberCheckbox"
                                        className="checkbox-input"
                                        name="ChangeChassisNo"
                                        checked={formData.ChangeChassisNo}
                                        onChange={handleChange}
                                    />
                                    <label
                                        for="chassisNumberCheckbox"
                                        className="checkbox-label"
                                    ></label>
                                </div>
                            </li>
                            <li>
                                <p>Make, Model, Variant:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="makeModelVariantCheckbox"
                                        className="checkbox-input"
                                        name="ChangeMakeModelVariant"
                                        checked={formData.ChangeMakeModelVariant}
                                        onChange={handleChange}
                                    />
                                    <label
                                        for="makeModelVariantCheckbox"
                                        className="checkbox-label"
                                    ></label>
                                </div>
                            </li>
                            <li>
                                <p>Fuel:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="fuelCheckbox"
                                        className="checkbox-input"
                                        name="ChangeFuelType"
                                        checked={formData.ChangeFuelType}
                                        onChange={handleChange}
                                    />
                                    <label for="fuelCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            <li>
                                <p>Name:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="nameCheckbox"
                                        className="checkbox-input"
                                        name="ChangeName"
                                        checked={formData.ChangeName}
                                        onChange={handleChange}
                                    />
                                    <label for="nameCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            <li>
                                <p>Address:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="addressCheckbox"
                                        className="checkbox-input"
                                        name="ChangeAddress"
                                        checked={formData.ChangeAddress}
                                        onChange={handleChange}
                                    />
                                    <label for="addressCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            <li>
                                <p>Email:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="emailCheckbox"
                                        className="checkbox-input"
                                        name="ChangeEmailId"
                                        checked={formData.ChangeEmailId}
                                        onChange={handleChange}
                                    />
                                    <label for="emailCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            {formData.ChangeEmailId && (
                                <li>
                                    <div className="floating-label">
                                        <input
                                            type="text"
                                            name="EmailId"
                                            value={formData.EmailId}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label>EmailId</label>
                                    </div>
                                </li>
                            )}
                            <li>
                                <p>Mobile:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="mobileCheckbox"
                                        className="checkbox-input"
                                        name="ChangeMobileNo"
                                        checked={formData.ChangeMobileNo}
                                        onChange={handleChange}
                                    />
                                    <label for="mobileCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            {formData.ChangeMobileNo && (
                                <li>
                                    <div className="floating-label">
                                        <input
                                            type="text"
                                            name="MobileNo"
                                            value={formData.MobileNo}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label>MobileNo</label>
                                    </div>
                                </li>
                            )}
                            <li>
                                <p>Deductible:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="deductibleCheckbox"
                                        className="checkbox-input"
                                        name="ChangeDeductible"
                                        checked={formData.ChangeDeductible}
                                        onChange={handleChange}
                                    />
                                    <label
                                        for="deductibleCheckbox"
                                        className="checkbox-label"
                                    ></label>
                                </div>
                            </li>
                            {formData.ChangeDeductible && (
                                <li>
                                    <div className="floating-label">
                                        <input
                                            type="text"
                                            name="Deductible"
                                            value={formData.Deductible}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label>Deductible</label>
                                    </div>
                                </li>
                            )}
                            <li>
                                <p>Premium:</p>
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="premiumCheckbox"
                                        className="checkbox-input"
                                        name="ChangePremiumMismatch"
                                        checked={formData.ChangePremiumMismatch}
                                        onChange={handleChange}
                                    />
                                    <label for="premiumCheckbox" className="checkbox-label"></label>
                                </div>
                            </li>
                            {formData.ChangePremiumMismatch && (
                                <li>
                                    <div className="floating-label">
                                        <input
                                            type="text"
                                            name="Premium"
                                            value={formData.Premium}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label>Deductible</label>
                                    </div>
                                </li>
                            )}
                            {(formData.ChangeVehicleNo ||
                                formData.ChangeEngineNumber ||
                                formData.ChangeChassisNo ||
                                formData.ChangeMakeModelVariant ||
                                formData.ChangeFuelType ||
                                formData.ChangeName ||
                                formData.ChangeAddress) && (
                                    <>
                                        <li>
                                            <div className="custom-file-upload">
                                                <input
                                                    type="file"
                                                    id="requestLetterUpload"
                                                    name="RequestLetterBase64"
                                                    onChange={handleFileChange}
                                                />
                                                <label for="requestLetterUpload">Upload Request Letter</label>
                                            <span className="file-Status">{formData.RequestLetterBase64 && <i class="far fa-check-circle"></i>}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="custom-file-upload">
                                                <input
                                                    type="file"
                                                    id="rcCopyUpload"
                                                    name="RCCopyBas64"
                                                    onChange={handleFileChange}
                                                />
                                                <label for="rcCopyUpload">Upload RC Copy</label>
                                            <span className="file-Status">{formData.RCCopyBas64 && <i class="far fa-check-circle"></i>}</span>
                                            </div>
                                        </li>
                                    </>
                                )}
                        </ul>
                        <button
                            className="btn-customr"
                            onClick={GetEndorsement}
                            disabled={isSubmitDisabled}
                        >
                            Submit
                        </button>
                    </div>
                </>
            )
                :
                (<>
                    <h4>Authentication</h4>
                    <div className="Endorsement box-2">
                        <label>
                            Enter the OTP sent to your number
                            <input
                                type="text"
                                name="otp"
                                value={formData.otp}
                                onChange={handleChange}
                            />
                            <p>
                                Didn't recieve OTP? <a>Resend OTP</a>
                            </p>
                        </label>
                        <button className="btn-customr" onClick={SubmitOTP}>
                            Continue
                        </button>
                    </div>
                </>
                )}
        </>
    );
};

export default EndorseForm;
